import React from "react";
import { Formik, Field } from "formik";
import { Button, Form } from "react-bootstrap";
import {
  FieldInput,
  FieldButtonGroup,
  FieldTextarea,
} from "../../../components";
import { setManageMasterToastInfo } from "../../../contexts";
import { returnOnlyIfBoolean, toOptionValuesFromMapper } from "../../../utils";
import { isEmpty, get } from "lodash";
import { UpsertClearingPartner } from "../../../services";
const aggregationLevelValues = {
  0: "Net-off",
  1: "Fully disclosed",
};
const bankAccountTypes = {
  1: "Saving",
  2: "Checking",
};
export const ClearingPartnerCreateEditSlider = (props) => {
  const { setEdit, data, create, clearingPartnerId, dispatch } = props;
  const initialValues = {
    bankAccountType: 1,
    accountAggregationLevel: 0,
  };

  const onFormSubmit = (values, { setFieldError, setFieldTouched }) => {
    // console.log(values,data,clearingPartnerId,"Values")

    const payload = {
      id: get(values, "id", 0),
      identifier: get(values, "clearingPartnerId", ""),
      description: get(values, "description", ""),
      clearingPartnerId: clearingPartnerId,
      accountAggregationLevel: get(values, "accountAggregationLevel", 0),
      bankAccountType: get(values, "bankAccountType", 1),
      accountNumber: get(values, "accountNumber", ""),
      bankName: get(values, "bankName", ""),
      abaRoutingNumber: get(values, "abaRoutingNumber", ""),
    };
    UpsertClearingPartner(payload)
      .then((response) => {
        if (response.isSuccessful) {
          setEdit();
          dispatch(
            setManageMasterToastInfo({
              showToast: true,
              toastMessage: "Data saved successfully",
            })
          );
        } else {
          for (var i = 0; i < response.errorMessages?.length; i++) {
            var _ = response.errorMessages[i];
            setFieldTouched(_.controlName, true);
            setFieldError(_.controlName, `${_.errorCode} : ${_.message}`);
          }
        }
      })
      .catch((err) => {});
  };

  return (
    <Formik
      initialValues={!isEmpty(data) ? data : initialValues}
      onSubmit={onFormSubmit}
      enableReinitialize
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({
        handleChange,
        setFieldValue,
        handleSubmit,
        setValues,
        values,
        setSubmitting,
        ...rest
      }) => {
        console.log(clearingPartnerId, values, "Values");
        return (
          <Form
            autoComplete="off"
            className="h-100"
            onSubmit={handleSubmit}
            validated={!isEmpty(rest.errors)}
          >
            <div className="inside-content">
              <div className="d-flex justify-content-between align-baseline clearing-partner-edit-slider">
                <div>
                  <p className="investment-heading">
                    {create ? "Create" : "Edit"} Clearing Partner ID
                  </p>
                </div>
                <div>
                  <Button variant="secondary" onClick={setEdit}>
                    Cancel
                  </Button>
                  <Button variant="primary" type="submit" className="ml-4">
                    Save
                  </Button>
                </div>
              </div>

              <Field
                size="md"
                isRequired
                name={"clearingPartnerId"}
                label={"Clearing Partner ID"}
                type="text"
                autoComplete="off"
                value={values["clearingPartnerId"]}
                onChange={handleChange}
                //   disabled={isAddedToMaster || (isEdit && !isSave)}
                component={FieldInput}
              />
              <Field
                size="md"
                name={"description"}
                label={"Description"}
                type="text"
                autoComplete="off"
                value={values["description"]}
                onChange={handleChange}
                //   disabled={isAddedToMaster || (isEdit && !isSave)}
                component={FieldTextarea}
              />

              <Field
                isRequired
                name={`accountAggregationLevel`}
                label="Account Aggregation Level"
                size="sm"
                options={toOptionValuesFromMapper(aggregationLevelValues)}
                selectedValue={values["accountAggregationLevel"]}
                onChange={(value) => {
                  setFieldValue(`accountAggregationLevel`, value);
                }}
                // disabled={isEdit && !isSave}
                component={FieldButtonGroup}
              />
              <div>Bank Details</div>
              <Field
                size="md"
                isRequired
                name={"bankName"}
                label={"Bank Name"}
                type="text"
                autoComplete="off"
                value={values["bankName"]}
                onChange={handleChange}
                //   disabled={isAddedToMaster || (isEdit && !isSave)}
                component={FieldInput}
              />
              <Field
                isRequired
                name={`bankAccountType`}
                label="Bank Account Type"
                size="sm"
                options={toOptionValuesFromMapper(bankAccountTypes)}
                selectedValue={values["bankAccountType"]}
                onChange={(value) => {
                  setFieldValue(`bankAccountType`, value);
                }}
                // disabled={isEdit && !isSave}
                component={FieldButtonGroup}
              />
              <Field
                size="md"
                isRequired
                name={"accountNumber"}
                label={"Bank Account Number"}
                type="text"
                autoComplete="off"
                value={values["accountNumber"]}
                onChange={handleChange}
                //   disabled={isAddedToMaster || (isEdit && !isSave)}
                component={FieldInput}
              />
              <Field
                size="md"
                isRequired
                name={"abaRoutingNumber"}
                label={"ABA Routing Number"}
                type="text"
                autoComplete="off"
                value={values["abaRoutingNumber"]}
                onChange={handleChange}
                //   disabled={isAddedToMaster || (isEdit && !isSave)}
                component={FieldInput}
              />
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};
